import { SegSvg } from '../../Components/SegUI/SegSvg/SegSvg'
import { SegHeaderLogo } from '../../Components/SegUI/SegHeaderLogo/SegHeaderLogo'
import logoblue from "../../Assets/img/logo_segurarse.svg"
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import styled from '@emotion/styled'
import { useConfiguracionEmpresa } from '../../Services/Providers/useConfiguracionEmpresa'
import { useEffect } from 'react'
import { useCotizacionStore } from '../../Services/Providers/CotizacionStore'
import guardarContacto from '../../Services/API/GuardarContacto'
import { useConfig } from '../../context/ConfigContext'
import { getInicioCotizacion } from '../../utils/getRubro'

interface GraciasProps {
    nombre?: string;
    telefono?: string;
    email?: string;
    vehiculo?: string;
    aseguradora?: string;
    tipo?: "emision" | "vehiculoantiguo";
    esMoto?: boolean;
}

const StyledDiv = styled.div`
height: 63vh;
@media (max-width: 458px) {
    height: 85vh;
}
@media (max-width: 278px) {
    height: 90vh;
}
`

export const GraciasMoto = ({ esMoto = true }: GraciasProps) => {

    const { compania } = useParams();
    const { config, origen } = useConfiguracionEmpresa();
    const { config: envConf } = useConfig();
    const { cotizacionValues, setCotizacionValues } = useCotizacionStore();
    const nav = useNavigate();

    useEffect(() => {
        if (origen === "SEGURARSE") {
            document.body.style.background = "#2c7dfd";
        } else {
            document.body.style.background = config.colors.primary;
        }
        return () => {
            document.body.style.background = "";
        };
    }, [config]);

    useEffect(() => {
        if (cotizacionValues.parametrosIniciales && !cotizacionValues?.contactoId) {
            const fetchData = async () => {
                const response: any = await guardarContacto(
                    "moto",
                    cotizacionValues?.parametrosIniciales.origen,
                    cotizacionValues?.parametrosIniciales.tipoCotizador,
                    cotizacionValues?.landingUrl,
                    cotizacionValues?.referer,
                    cotizacionValues?.patente,
                    cotizacionValues?.marca?.value,
                    cotizacionValues?.modelo?.value,
                    cotizacionValues?.version?.value,
                    cotizacionValues?.año?.value,
                    cotizacionValues?.email,
                    cotizacionValues?.telefono?.prefijo,
                    cotizacionValues?.telefono?.numero,
                    cotizacionValues?.fechaNac?.dia +
                    "/" +
                    cotizacionValues?.fechaNac?.mes +
                    "/" +
                    cotizacionValues?.fechaNac?.año,
                    cotizacionValues?.genero?.value === "M" ? "Masculino" : "Femenino",
                    cotizacionValues?.provincia?.value,
                    cotizacionValues?.localidad?.value,
                    cotizacionValues?.nombre,
                    cotizacionValues?.apellido,
                    cotizacionValues?.cuandoContrata?.label,
                    cotizacionValues?.captchaToken
                );
                if (response.data) {
                    if (
                        response.data.api_status === 200 &&
                        response.data.api_data !== null
                    ) {
                        setCotizacionValues({
                            ...cotizacionValues,
                            contactoId: response.data.api_data.idContacto,
                            sumaAseguradaIA: response.data.api_data.sumaAseguradaIA,
                            token: response.data.api_data.token,
                        });
                    } else if (
                        response.data.api_data ===
                        "El Mail informado no es un mail válido"
                    ) {
                        compania
                            ? nav(
                                "/moto/cotizacion/" +
                                compania +
                                "/email?error=Por favor, ingresá una dirección de correo electrónico válida"
                            )
                            : nav(
                                "/moto/cotizacion/email?error=Por favor, ingresá una dirección de correo electrónico válida"
                            );
                    } else if (response.data.api_data === "El Captcha no es válido") {
                        compania
                            ? nav(
                                "/moto/cotizacion/" +
                                compania +
                                "/codigo-postal?error=El Captcha no es válido"
                            )
                            : nav(
                                "/moto/cotizacion/codigo-postal?error=El Captcha no es válido"
                            );
                    } else if (response.data.api_data === "Origen Inválido") {
                        nav(getInicioCotizacion("moto", compania) + "?error=Orígen inválido");
                    } else if (
                        response.data.api_data === "El Teléfono informado no es válido"
                    ) {
                        compania
                            ? nav(
                                "/moto/cotizacion/" +
                                compania +
                                "/telefono?error=Por favor, ingresá un n° de teléfono válido"
                            )
                            : nav(
                                "/moto/cotizacion/telefono?error=Por favor, ingresá un n° de teléfono válido"
                            );
                    } else if (
                        response.data.api_data === "La localidad no es válida."
                    ) {
                        compania
                            ? nav(
                                "/moto/cotizacion/" +
                                compania +
                                "/codigo-postal?error=Por favor, ingresá nuevamente la localidad"
                            )
                            : nav(
                                "/moto/cotizacion/codigo-postal?error=Por favor, ingresá nuevamente la localidad"
                            );
                    } else if (
                        response.data.api_data.startsWith(
                            "*** Se recibió cotización BLOQUEADA"
                        )
                    ) {
                        var props = {
                            nombre:
                                cotizacionValues.nombre + " " + cotizacionValues.apellido,
                            email: cotizacionValues.email!,
                            telefono:
                                cotizacionValues.telefono?.prefijo +
                                "" +
                                cotizacionValues.telefono?.numero,
                            vehiculo:
                                cotizacionValues.marca?.value +
                                " " +
                                cotizacionValues.version?.value +
                                " " +
                                cotizacionValues.año?.value,
                            aseguradora: "Sin seleccionar",
                            tipo: "emision",
                        };
                        compania
                            ? nav("/moto/gracias-alt/" + compania, { state: props })
                            : nav("/moto/gracias-alt", { state: props });
                    } else {
                        nav("/moto/error");
                    }
                } else {
                    compania
                        ? nav(
                            "/moto/cotizacion/" +
                            compania +
                            "/codigo-postal?error=Error de conexion."
                        )
                        : nav(
                            "/moto/cotizacion/codigo-postal?error=Error de conexion."
                        );
                }
            };
            fetchData();
        }
    }, [])
    const getMotoCotizada = () => {
        let moto = cotizacionValues.marca?.value || " ";
        moto += " " + cotizacionValues.modelo?.value || " ";
        moto += " " + cotizacionValues.version?.value || " ";
        moto += " " + cotizacionValues.año?.value || "";

        return moto;
    }

    return (
        <div>
            <SegSvg />
            <header className="site-header sticky-lg-top">
                <div className="container">
                    {
                        origen !== "SEGURARSE" ?
                            <div className="row">
                                <div className="col-md-6 offset-md-3 text-center d-flex justify-content-center gap-3">
                                    {" "}
                                    {/* Centra el contenido en la columna */}
                                    <SegHeaderLogo
                                        img={config.images.logo}
                                        alt="Logo Segurarse"
                                        width={window.innerWidth > 768 ? "150px" : "120px"}
                                        style={{ filter: "grayscale(100%) brightness(50%)" }}
                                    />
                                    <div style={{ height: "100%", width: "2px", backgroundColor: "gray" }}></div>
                                    <SegHeaderLogo
                                        img={logoblue}
                                        alt="Logo Segurarse"
                                        width={window.innerWidth > 768 ? "140px" : "120px"}
                                        style={{ filter: "grayscale(100%)" }}
                                    />
                                </div>
                            </div>
                            :
                            <div className="row">
                                <div className="col-md-6 offset-md-3 text-center">
                                    {" "}
                                    {/* Centra el contenido en la columna */}
                                    <SegHeaderLogo
                                        img={logoblue}
                                        alt="Logo Segurarse"
                                        width="160px"
                                    />
                                </div>
                            </div>
                    }

                </div>
            </header>
            <div style={origen !== "SEGURARSE" ? { background: config.colors.primary } : {}}>
                <div className="text-center pt-5" style={{ height: "25vh" }}>
                    <svg className="" style={{ width: "150px" }}>
                        <use href={esMoto ? "#ico-moto" : "#ico-auto"} fill='white' />
                    </svg>
                </div>
                <div className='text-center d-flex flex-column mt-5'>
                    <h1 className='fs-2 text-white'>¡Recibimos tu solicitud!</h1>
                    <div className='mb-5 mt-4 ps-3 pe-3'>
                        <div className='bg-white rounded container' style={origen !== "SEGURARSE" ? { backgroundColor: config.colors.tertiary } : {}}>
                            <div>
                                <div className='d-flex flex-wrap'>
                                    <div className='col-12 col-sm-11 col-md-6 col-lg-4  pt-4'>
                                        <div className="d-flex align-items-start gap-2">
                                            <div className=''>
                                                <svg className="" style={{ width: "1.5em", height: "1.5em" }}>
                                                    <use xlinkHref="#card-lin" fill={origen !== "SEGURARSE" ? config.colors.secondary : undefined} />
                                                </svg>
                                            </div>
                                            <span>Nombre:</span>
                                            <span className='fw-bold'>{cotizacionValues.nombre || "" + cotizacionValues.apellido || ""}</span>
                                        </div>
                                    </div>
                                    <div className='col-12 col-sm-11 col-md-6 col-lg-4  pt-4'>
                                        <div className="d-flex align-items-start gap-2">
                                            <div className=''>
                                                <svg className="" style={{ width: "1.5em", height: "1.5em" }}>
                                                    <use xlinkHref="#tel-lin" fill={origen !== "SEGURARSE" ? config.colors.secondary : undefined} />
                                                </svg>
                                            </div>
                                            <span>Telefono:</span>
                                            <span className='fw-bold'>{cotizacionValues.telefono?.prefijo + " " + cotizacionValues.telefono?.numero}</span>
                                        </div>
                                    </div>
                                    <div className='col-12 col-sm-11 col-md-6 col-lg-4  pt-4'>
                                        <div className="d-flex align-items-start gap-2">
                                            <div className=''>
                                                <svg className="" style={{ width: "1.5em", height: "1.5em" }}>
                                                    <use xlinkHref="#envelope-lin" fill={origen !== "SEGURARSE" ? config.colors.secondary : undefined} />
                                                </svg>
                                            </div>
                                            <span>Email:</span>
                                            <span className='fw-bold text-truncate'>{cotizacionValues.email}</span>
                                        </div>
                                    </div>
                                    <div className='col-8 col-sm-8 col-md-11 col-lg-11  pt-4 pb-5'>
                                        <div className="d-flex align-items-start gap-2">
                                            <div className=''>
                                                <svg className="" style={{ width: "1.5em", height: "1.8em" }}>
                                                    <use xlinkHref={"#ico-moto"}
                                                        fill={origen !== "SEGURARSE" ? config.colors.secondary : undefined} />
                                                </svg>
                                            </div>
                                            <span>{"Moto cotizada:"}</span>
                                            <span className='fw-bold '>{getMotoCotizada()}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                               (origen === "SEGURARSE") &&
                                <a
                                    target='_blank' rel='noreferrer' className='text-black'
                                    href={`https://api.whatsapp.com/send/?phone=${envConf.pais === "AR" ? "5491128357048" : "59892281806"}&text=${""}&type=phone_number&app_absent=0`}>
                                    <div className='d-flex justify-content-center gap-2 align-items-start'>
                                        <div>
                                            <p className='fw-bold'>¿Querés continuar por WhatsApp? <span className='fw-normal'>Chatéanos</span></p>
                                        </div>
                                        <div>
                                            <svg className="" style={{ width: "1.5em", height: "1.8em", paddingBottom: "5px" }}>
                                                <use xlinkHref="#whatsapp" />
                                            </svg>
                                        </div>
                                    </div>
                                </a>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
